import { Box, Flex, Heading } from '@conteg/ui';

type Props = {
  title?: string;
  mainFilter?: React.ReactNode;
  filters?: React.ReactNode;
  commitFiltersButton?: React.ReactNode;
  clearFiltersButton?: React.ReactNode;
};

export default function AuditViewFilterHeader({
  title,
  mainFilter,
  filters,
  clearFiltersButton,
}: Props) {
  return (
    <Box marginBottom="4rem">
      <Flex
        flexDirection="row"
        alignItems="center"
        marginBottom="4rem"
        gap="3rem"
        flexWrap="wrap"
      >
        <Heading variant="h2" title={title} />
        <Box style={{ minWidth: '250px' }}>{mainFilter}</Box>
      </Flex>

      <Flex flexDirection="row" alignItems="center" gap="3rem" flexWrap="wrap">
        {filters}

        <Box marginLeft="auto">{clearFiltersButton}</Box>
      </Flex>
    </Box>
  );
}
